import getApi from '@/lib/axios';
import { OccupancyDashboardType } from '../types';

export type ResponsibleDTO = OccupancyDashboardType;

type Params = {
  serie: string;
  turma: string;
  turno: string;
  serie_id: number;
  turma_id: number;
  turno_id: number;
}

type Filters = {
  serieId: number | string;
  serie: string;
  turma: string;
  turno: string;
  turmaId: number | string;
  turnoId: number | string;
}

async function listAllOccupancyDashboard(filters: Filters) {
  const api = await getApi();

  const params = {} as Params;

  if (filters.serie) {
    params.serie = filters.serie;
  }

  // prefer numeric serie_id if provided
  if (filters.serieId) {
    // if serieId looks like a number, send serie_id param
    const n = Number(filters.serieId);
    if (!Number.isNaN(n)) {
      (params as any).serie_id = n;
    }
  }

  if (filters.turma) {
    params.turma = filters.turma;
  }

  if (filters.turno) {
    params.turno = filters.turno;
  }

  return api.get<OccupancyDashboardType[]>('/painel-ocupacao/', { params });
}

export { listAllOccupancyDashboard };
